import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAskBluejApiContext } from '../api/context';

export function useUserOrganizationQuery(): UseQueryResult<{
  id: string,
  name: string,
  sector: string,
  webSearchEnabled: boolean,
  projectFilesEnabled: boolean,
  taxNotesContentViewerEnabled: boolean
}> {
  const { api } = useAskBluejApiContext();

  return useQuery({
    queryKey: ['user-organization'],
    queryFn: async () => {
      const organizations = await api.getUserOrganization();
      return organizations[0] ?? null;
    },
    staleTime: Infinity,
    gcTime: Infinity
  });
}
